import type { IObservableValue } from '../../mainMenu/types';

interface GeoLocatorConstructorParams {
  tier1CountryCodes: string[];
}

interface GeoLocatorServiceDependencies {
  observable: IObservableValue<{geoLocation: {
      tier1: boolean;
      fetchTime: number;
    } | null}>;
}

export class GeoLocator {
  private serviceDependencies: GeoLocatorServiceDependencies | null = null;

  private readonly geoFallback = navigator.language.split('-').pop() ?? '**';

  constructor(private readonly params: GeoLocatorConstructorParams) {
  }

  public async init(dependencies: GeoLocatorServiceDependencies, fetchFunction: () => Promise<boolean>): Promise<void> {
    this.serviceDependencies = dependencies;

    const isTier1 = await fetchFunction();

    dependencies.observable.updateValue({
      geoLocation: {
        tier1: isTier1,
        fetchTime: Date.now(),
      },
    });
  }

  public isTier1(): boolean {
    const savedValue = this.serviceDependencies?.observable?.getValue().geoLocation;
    return savedValue ? savedValue.tier1 : this.params.tier1CountryCodes.includes(this.geoFallback);
  }
}
